var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"portfolio_edit_textarea mt10"},[_c('quill-editor',{ref:"contentEditor",staticClass:"h300",attrs:{"options":_vm.editorOption},model:{value:(_vm.portfolio),callback:function ($$v) {_vm.portfolio=$$v},expression:"portfolio"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }